import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData, imgUrl } from '../Services/api';

const UserView = () => {
    const { id } = useParams();
    const [managers, setManagers] = useState([])
    const [values, setValues] = useState({
        username: "",
        email: "",
        mobile: "",
        password: "",
        role: "salesperson",
        profile_image: null,
    })


       // fetch all managers
            const fetchManagers = async () => {
                try {
                    const res = await getData('/users/getAllManager')
                    if (res.success) {
                        setManagers(res.data)
                    }
                } catch (error) {
                    console.error("Error fetching managers", error)
                }
            }


    const fetchUserDetails = async () => {
        try {
            const res = await getData(`/users/details/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch user details", error)
        }
    }

    useEffect(() => {
        fetchUserDetails();
        fetchManagers()
    }, [id])
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/users/user-list">Salesmen</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Salesmen Details
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Salesmen Details</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="tab-content">
                                <div className="row">
                                    <div className="col-lg-12 col-xxl-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12 text-center mb-3">
                                                        <div className="user-upload wid-75">
                                                            <img
                                                                src={values.profile_image ? `${values.profile_image}` : avtar5}
                                                                alt="img"
                                                                className="img-fluid"
                                                            />
                                                            <label htmlFor="uplfile" className="img-avtar-upload">
                                                                <i className="fa fa-camera f-24 mb-1" />
                                                                <span>Upload</span>
                                                            </label>
                                                            <input type="file" id="uplfile" className="d-none" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">Salesmen Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter username"
                                                                name='username'
                                                                value={values.username}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="form-label">Contact Number</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Enter Contact number"
                                                                name='mobile'
                                                                value={values.mobile}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">Email</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Email"
                                                                name='email'
                                                                value={values.email}
                                                                disabled
                                                            />
                                                        </div>


                                                         <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label">Select Manager</label>
                                                            <select
                                                                className='form-select'
                                                                name='manager_id'
                                                                value={values.manager_id} disabled
                                                            >
                                                                <option value="">-- Select Manager --</option>
                                                                {managers.map(manager => (
                                                                    <option key={manager.id} value={manager.id}>
                                                                        {manager.username} ({manager.email})
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                        {/* <div className="form-group">
                                                            <label className="form-label">Role</label>
                                                            <select className='form-select' name='role' value={values.role} disabled>
                                                                <option value="salesperson">Salesperson</option>
                                                                <option value="manager">Manager</option>
                                                            </select>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserView

